import { useState } from "react";
import { LayoutDashboard, Store, Users, ShoppingBag, Mail, CalendarDays, Handshake } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { OverviewTab } from "@/components/admin/OverviewTab";
import { BrandsTab } from "@/components/admin/BrandsTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { OrdersTab } from "@/components/admin/OrdersTab";
import { NewsletterTab } from "@/components/admin/NewsletterTab";
import { EditionsTab } from "@/components/admin/EditionsTab";
import { ProposalsTab } from "@/components/admin/ProposalsTab";

const TABS = [
  { id: "overview", label: "Panoramica", icon: LayoutDashboard },
  { id: "editions", label: "Calendari", icon: CalendarDays },
  { id: "brands", label: "Brand", icon: Store },
  { id: "proposals", label: "Proposte", icon: Handshake },
  { id: "users", label: "Utenti", icon: Users },
  { id: "orders", label: "Acquisti", icon: ShoppingBag },
  { id: "newsletter", label: "Newsletter", icon: Mail },
];

export default function Admin() {
  const [tab, setTab] = useState("overview");

  return (
    <div className="relative min-h-screen bg-[#06150F] text-[#FAF6EE]">
      <SiteHeader />
      <main className="mx-auto max-w-7xl px-5 pb-24 pt-8 sm:px-8">
        <h1 data-testid="admin-title" className="font-display text-3xl font-bold text-amber-100">
          Pannello di controllo
        </h1>
        <p className="mt-1.5 text-sm text-emerald-100/60">Gestisci calendari, brand, utenti, acquisti e newsletter.</p>

        <div className="mt-7 flex gap-2 overflow-x-auto pb-1" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              data-testid={`admin-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`flex shrink-0 items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-semibold transition-colors ${
                tab === t.id
                  ? "border-amber-400/70 bg-amber-400/15 text-amber-200"
                  : "border-amber-500/20 text-emerald-100/60 hover:border-amber-500/40 hover:text-amber-200"
              }`}
            >
              <t.icon className="h-4 w-4" /> {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8">
          {tab === "overview" && <OverviewTab />}
          {tab === "editions" && <EditionsTab />}
          {tab === "brands" && <BrandsTab />}
          {tab === "proposals" && <ProposalsTab />}
          {tab === "users" && <UsersTab />}
          {tab === "orders" && <OrdersTab />}
          {tab === "newsletter" && <NewsletterTab />}
        </div>
      </main>
    </div>
  );
}
